

import { Component, Prop } from 'vue-property-decorator'
import { Bar } from 'vue-chartjs/legacy'


import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

import Base from "../../../core/components/Base.vue";


ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


@Component({
  components: { Bar }
})
export default class BarChart extends Base {


  get statistics() {
    return this.$store.state.booking.bookingStatistics;
  }

  @Prop({ default: 'bar-chart' }) chartId!: string

  @Prop({ default: 'label' }) datasetIdKey!: string

  @Prop({ default: 50 }) width!: number

  @Prop({ default: 25 }) height!: number

  @Prop() period !: string

  barChartConfig = {
    labels: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
    datasets: [
      {
        label: 'Nb moyen de réservations/jour',
        data: [
          this.statistics.average.monday,
          this.statistics.average.tuesday,
          this.statistics.average.wednesday,
          this.statistics.average.thursday,
          this.statistics.average.friday,
          this.statistics.average.saturday,
          this.statistics.average.sunday,
        ],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
        ],
        borderColor: [
        ],
        barPercentage: 1,
        categoryPercentage: 0.5

      }
    ]

  }

  test(number: number) {
    return number * 2
  }

  options = {
    responsive: true,
    plugins: {
      tooltip: {
        titleFont: {
          size: 18
        },
        bodyFont: {
          size: 16
        },
        footerFont: {
          size: 14
        },
        boxPadding: 10,
        padding: 12,
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          usePointStyle: true,
          font: {
            size: 16
          },
        }
      },
    },

    scales: {
      y: {
        display: true,
        min: 0,
        ticks: {
          display: true,
          stepSize: 20,
        },
        grid: {
          drawOnChartArea: false,
          drawTicks: true
        },
        scaleLabel: { display: false },
        title: {
          display: true,
          text: 'Nb réservations',
          font: {
            size: 11
          }
        }
      }
    }
  }
}

